"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HelperUtils_1 = require("utils/HelperUtils");
const ListEmptyState_1 = __importDefault(require("./ListEmptyState"));
function ActivitiesEmptyState({ title, description }) {
    return (react_1.default.createElement(ListEmptyState_1.default, { fullHeight: true, containerClassname: "my-[40px]", emptyIcon: "icon-no-activities", title: (0, HelperUtils_1.getObjectiveLocale)(title ? title : 'No Activities yet'), subtitle: `${(0, HelperUtils_1.getObjectiveLocale)(description
            ? description
            : "Check back later for updates on the goal and task you're involved")} ` }));
}
exports.default = ActivitiesEmptyState;
